module.exports = __webpack_public_path__ + "img/herby-prizes.ea9e4da8.png";